import { Breadcrumbs, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { useWindowDimensions } from "../../hooks/useWindowDimensions";

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
    textAlign: "center",
  },
  linkText: {
    textDecoration: "none",
    color: theme.palette.text.secondary,
    fontWeight: 500,
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export const AppFooter = () => {
  const classes = useStyles();
  const { width } = useWindowDimensions();
  // TODO: Change link address
  return (
    <footer className={classes.footer}>
      {width >= 600 && (
        <div style={{ display: "inline-block", marginBottom: 16 }}>
          <Breadcrumbs
            separator="|"
            aria-label="breadcrumb"
            style={{ textAlign: "left", fontWeight: 500 }}
          >
            <a
              className={classes.linkText}
              href="https://pprct.net/terms/"
              target="_blank"
              rel="noopener"
            >
              Terms of Use
            </a>
            <a
              className={classes.linkText}
              href="https://pprct.net/privacy/"
              target="_blank"
              rel="noopener"
            >
              Privacy Policy
            </a>
            <a
              className={classes.linkText}
              href="https://pprct.net/特商法表記/"
              target="_blank"
              rel="noopener"
            >
              Specified Commercial Transaction Act
            </a>
          </Breadcrumbs>
        </div>
      )}
      <div>
        <Typography variant="body2" color="textSecondary" align="center">
          {"Copyright © "}
          TART K.K.
          {new Date().getFullYear()}
          {"."}
        </Typography>
      </div>
    </footer>
  );
};
